<template>
  <div id="userMenu">
    <div v-if="userSignedIn">
      <v-badge
        color="secondary"
        bordered
        overlap
        offset-x="15"
        offset-y="15"
        class="mr-3 mr-md-4"
      >
        <template v-slot:badge>
          <span>{{ cartItemCount }}</span>
        </template>
        <v-btn icon color="primary" dark to="/shopping-cart">
          <v-icon large>shopping_cart</v-icon>
        </v-btn>
      </v-badge>

      <v-menu :close-on-content-click="false" offset-y>
        <template v-slot:activator="{ on }">
          <v-btn icon color="primary" dark v-on="on" class="mr-5 mr-md-0 mt-1">
            <v-icon large>person</v-icon>
          </v-btn>
        </template>

        <v-card>
          <v-list nav>
            <v-list-item>
              <v-list-item-avatar color="grey lighten-2">
                <v-icon>person</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>{{ user.displayName }}</v-list-item-title>
                <v-list-item-subtitle>{{ user.email }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>

          <v-divider />

          <v-list dense nav>
            <v-list-item @click.prevent="goTo({ name: 'classroom' })">
              <v-list-item-icon>
                <v-icon>dashboard</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Eğitimlerim</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item @click.prevent="goTo({ name: 'settings' })">
              <v-list-item-icon>
                <v-icon>settings</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Ayarlar</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item @click.prevent="goTo({ name: 'orders' })">
              <v-list-item-icon>
                <v-icon>history</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Siparişlerim</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>

          <v-divider />

          <v-list dense nav>
            <v-list-item @click.prevent="signOut()">
              <v-list-item-icon>
                <v-icon>exit_to_app</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Çıkış</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-menu>
    </div>
    <ul v-else-if="!userSignedIn" class="menuItems">
      <v-btn
        id="signInBtn"
        class="d-none d-md-block mr-md-4 dfx-btn-primary"
        rounded
        color="purple"
        dark
        large
        @click="goTo('/signin')"
        >GİRİŞ YAP</v-btn
      >

      <v-btn
        id="signUpBtn"
        class="d-none d-md-block dfx-btn-secondary"
        rounded
        color="purple"
        dark
        large
        @click="goTo('/signup')"
        >KAYIT OL</v-btn
      >
    </ul>
  </div>
</template>

<script>
export default {
  computed: {
    userSignedIn() {
      return this.$store.getters["auth/userSignedIn"];
    },
    user() {
      return this.$store.getters["auth/user"];
    },
    cartItemCount() {
      return this.$store.getters["ecommerce/cartItemCount"];
    }
  },
  methods: {
    goTo(path) {
      this.$router.push(path).catch(() => {});
    },
    signOut() {
      this.$store.dispatch("auth/signOut");
      this.$router
        .replace({
          name: "home"
        })
        .catch(() => {});
    }
  }
};
</script>
